export default __webpack_public_path__ + "static/media/FEST_logo_poster-wrapper.b9e6465e.jpg";